// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  :host {
    display: flex;
    flex-grow: 1;
  }
  `, "",{"version":3,"sources":["webpack://./src/app/components/device-map/devices-map.ts"],"names":[],"mappings":";EACE;IACE,aAAa;IACb,YAAY;EACd","sourcesContent":["\n  :host {\n    display: flex;\n    flex-grow: 1;\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
